import { DateInput } from '@mantine/dates';
import styled from '@emotion/styled';

const StyledDateInput = styled(DateInput)``;
export default StyledDateInput;
